import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  parentRoot: {
    display: 'grid',
    gridTemplateColumns: 'auto minmax(1px,1fr) auto',
    alignItems: 'center',
    width: '100%',
    '& input[type=checkbox]': {
      accentColor: theme.palette.primary.main
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: 'minmax(1px,1fr) auto'
    }
  },
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '17px',
    fontSize: theme.size.sm,
    cursor: 'pointer',
    '& .task-details-btn': {
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    }
  },

  title: {
    display: 'flex',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    cursor: ({ canEdit }) => (canEdit ? 'pointer' : 'default'),
    //@ts-ignore
    color: theme.palette.textAlt,
    textDecoration: ({ closed }) => (closed ? 'line-through' : 'none'),
    alignItems: 'center',

    '& .content': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    }
  },

  titleBold: {},

  titleLight: {},

  parent: {
    color: theme.palette.primary.main,
    textDecoration: 'underline'
  },

  arrow: {
    margin: '0 0.5rem -4px 0.5rem',
    fontSize: theme.size.base,
    color: theme.palette.primary.main,
    height: '1rem',
    width: '1rem'
  },

  count: {
    color: theme.palette.primary.main,
    display: 'flex',
    alignItems: 'center',

    '& .count': {
      marginRight: '4px'
    },

    '& .icon': {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.textAlt
    }
  },

  hoverableIconContainer: {
    padding: '0 3px',
    borderRadius: '0.25rem',

    '&:hover': {
      backgroundColor: theme.palette.secondary.main
    }
  },

  isViewing: {
    backgroundColor: theme.palette.secondary.main
  },

  icon: {
    color: theme.palette.textAlt,
    transform: 'rotate(90deg)'
  },

  input: {
    flex: '1',
    display: 'flex',
    alignItems: 'center',

    '& input': {
      outline: 'none',
      border: 'none',
      padding: '0',
      fontSize: theme.size.sm,
      fontWeight: ({ lighter }) =>
        lighter ? theme.bold.base : theme.bold.bold,
      background: 'none',
      color: theme.palette.textAlt,
      overflow: 'hidden',
      textDecoration: ({ closed }) => (closed ? 'line-through' : 'none')
    },

    '& .button': {
      minWidth: '45px',
      padding: '0.125rem 0',
      fontSize: theme.size.sm
    }
  },

  details: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '0.25rem 0 0 0.25rem',
    paddingLeft: '0.25rem',
    background: 'white',

    '& > :not(:last-child)': {
      marginRight: '10px'
    }
  },

  edit: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: '0.5rem',
    color: theme.palette.textAlt,
    opacity: '0.35',
    minWidth: '1rem',
    marginRight: '0.5rem'
  },

  detailsIcon: {
    marginLeft: 6
  },

  hoverContainer: {
    display: 'flex',
    gap: '0.5rem'
  },

  checkboxContainer: {
    position: 'relative',
    minWidth: '14px',
    minHeight: '14px',
    margin: '0',
    marginRight: '0.5rem'
  },

  checkbox: {
    position: 'absolute',
    margin: '0',
    cursor: 'pointer'
  }
}))

export default useStyles
